import CreepyLogo from '../assets/images/logo/LogoCreepy.png'
import Creepys1 from '../assets/images/thumbnails/Creepy1.jpg'
import Creepys2 from '../assets/images/thumbnails/Creepy2.jpg'
import Creepys3 from '../assets/images/thumbnails/Creepy3.jpg'
import Creepys4 from '../assets/images/thumbnails/Creepy4.jpg'
import Creepys5 from '../assets/images/thumbnails/Creepy5.png'
import Creepys6 from '../assets/images/thumbnails/Creepy6.png'
import CreepyP1 from '../assets/images/preview/CreepyP1.png'
import CreepyP2 from '../assets/images/preview/CreepyP2.png'
import CreepyP3 from '../assets/images/preview/CreepyP3.png'
import CreepyP4 from '../assets/images/preview/CreepyP4.png'
import CreepyP5 from '../assets/images/preview/CreepyP5.png'
import CreepyP6 from '../assets/images/preview/CreepyP6.png'

const Creepys = [
  {
    id: 1,
    section: 'Creepy',
    title: 'Super Mario 64 : El Course 16',
    thumbnailUrl: Creepys1,
    webUrl: 'https://www.youtube.com/embed/F8MkxRpT3go', // Add the episode URL
    backgroundImage: CreepyP1,
    seriesLogo: CreepyLogo,
    description: 'Mi primer Creepypasta al igual que mi primer video loquendo, no sean duros conmigo, que es mi primera ves haciendo ambas cosas asi que tengo derecho a equivocarme ;)',
  },
  {
    id: 2,
    section: 'Creepy',
    title: "Zelda Majora's Mask : La Máscara de la Condena",
    thumbnailUrl: Creepys2,
    webUrl: 'https://www.youtube.com/embed/I3Mylg1dvSk', // Add the episode URL
    backgroundImage: CreepyP2,
    seriesLogo: CreepyLogo,
    description: 'Si si, se que está muy largo, es que mi imaginación fue más allá de lo que creí que podría ir cuando hice éste Creepypasta. Recuerden no ir al cementerio de Ikana en el cuarto día...',
  },
  {
    id: 3,
    section: 'Creepy',
    title: 'El Despertador',
    thumbnailUrl: Creepys3,
    webUrl: 'https://www.youtube.com/embed/NVIEBwW07mY', // Add the episode URL
    backgroundImage: CreepyP3,
    seriesLogo: CreepyLogo,
    description: 'Este TANPOCO es el video ganador de la votación de 2000 Subs, de nuevo, el verdadero ganador está demorando, y de mientras este XD. Bueno, esta historia, la escribí NO con el propósito de cagarte muuuucho de miedo, sino con el de hacer una más extensa, compleja, y completa que mis 2 Creepypastas anteriores, ojala les guste, y por favor pónganle atención :) Pero parece que si los cagó de miedo..... ._.',
  },
  {
    id: 4,
    section: 'Creepy',
    title: 'Toc Toc',
    thumbnailUrl: Creepys4,
    webUrl: 'https://www.youtube.com/embed/hu-XjKO7y3Y', // Add the episode URL
    backgroundImage: CreepyP4,
    seriesLogo: CreepyLogo,
    description: 'Feliz Halloween :) Bueno, este es mi primer Creepypasta EN TERCERA PERSONA, oajala les guste :D. Y cuidado al abrir la puerta, nunca sabes si en verdad se trata de un niño en busca de dulces...',
  },
      {
        id: 5,
        section: 'Creepy',
        title: 'Creepypasta : Mira atrás de tí X Marlo [Loquendo]',
        thumbnailUrl: Creepys5,
        webUrl: 'https://www.youtube.com/embed/jgJuPzYmv60', // Add the episode URL
        backgroundImage: CreepyP5,
        seriesLogo: CreepyLogo,
        description: 'Bienvenidos al especial de Halloween!! Aquí se mostrarán 2 Creepypastas hechos por la comunidad: Mira atrás de tí por Juan Andrés Briceño:  juanandr3sbricen0  / Marlo por Viche Mimi: https://www.facebook.com/profile.php?...',
      },

      {
        id: 6,
        section: 'Creepy',
        title: 'LegoBob || ¿Te Parece Divertido?',
        thumbnailUrl: Creepys6,
        webUrl: 'https://www.youtube.com/embed/Lu_9HJBovso', // Add the episode URL
        backgroundImage: CreepyP6,
        seriesLogo: CreepyLogo,
        description: 'Despues de cobrar venganza contra Rodrigo, LegoBob regresa a terminar con lo que empezó. ¿Logrará Burro resolver este gran misterio a tiempo? \n Este video está basado en la Creepypasta hecha por Rodrigo TheMarioDimension. No es parte del canon de LegoBob ni Dúper Mario Bros.',
      },
    // Add more episodes as needed
  ];

  export default Creepys;
